module.exports = __webpack_public_path__ + "img/亚洲清洁空气中心.d158b770.png";